import React, { useEffect, useState } from "react";
import type { Placement } from "@floating-ui/dom";
import { attachTooltip } from "../lib/bubble";

/**
 * L'infobulle d'un élément React — la même que le contrôleur Stimulus `tooltip` (lib/bubble) :
 * même délai, même style, même placement. L'enfant reçoit la ref (un élément DOM, ou un
 * composant qui la transmet).
 */
export default function Tooltip({
  children,
  text,
  placement = "bottom",
}: {
  text: string;
  children: JSX.Element;
  placement?: Placement;
}) {
  const [element, setElement] = useState<HTMLElement | null>(null);

  useEffect(() => (element ? attachTooltip(element, { text, placement }) : undefined), [element, text, placement]);

  return React.cloneElement(React.Children.only(children), { ref: setElement });
}
